import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MergeLoadMutationVariables = Types.Exact<{
  input: Types.MergeLoadInput;
}>;


export type MergeLoadMutation = { __typename?: 'Mutation', mergeLoad: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteLoadMutationVariables = Types.Exact<{
  input: Types.DeleteLoadInput;
}>;


export type DeleteLoadMutation = { __typename?: 'Mutation', deleteLoad: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLoadMilesMutationVariables = Types.Exact<{
  input: Types.SetLoadMilesInput;
}>;


export type SetLoadMilesMutation = { __typename?: 'Mutation', setLoadMiles: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearLoadMilesMutationVariables = Types.Exact<{
  input: Types.ClearLoadMilesInput;
}>;


export type ClearLoadMilesMutation = { __typename?: 'Mutation', clearLoadMiles: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLoadPickupWindowMutationVariables = Types.Exact<{
  input: Types.SetLoadPickupWindowInput;
}>;


export type SetLoadPickupWindowMutation = { __typename?: 'Mutation', setLoadPickupWindow: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type ClearLoadPickupWindowMutationVariables = Types.Exact<{
  input: Types.ClearLoadPickupWindowInput;
}>;


export type ClearLoadPickupWindowMutation = { __typename?: 'Mutation', clearLoadPickupWindow: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type SetLoadTransitKindMutationVariables = Types.Exact<{
  input: Types.SetLoadTransitKindInput;
}>;


export type SetLoadTransitKindMutation = { __typename?: 'Mutation', setLoadTransitKind: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type SetLoadDockMutationVariables = Types.Exact<{
  input: Types.SetLoadDockInput;
}>;


export type SetLoadDockMutation = { __typename?: 'Mutation', setLoadDock: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearLoadDockMutationVariables = Types.Exact<{
  input: Types.ClearLoadDockInput;
}>;


export type ClearLoadDockMutation = { __typename?: 'Mutation', clearLoadDock: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetLoadStopPlannedTimeMutationVariables = Types.Exact<{
  input: Types.SetLoadStopPlannedTimeInput;
}>;


export type SetLoadStopPlannedTimeMutation = { __typename?: 'Mutation', setLoadStopPlannedTime: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearLoadStopPlannedTimeMutationVariables = Types.Exact<{
  input: Types.ClearLoadStopPlannedTimeInput;
}>;


export type ClearLoadStopPlannedTimeMutation = { __typename?: 'Mutation', clearLoadStopPlannedTime: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsLoadStateFieldsFragment = { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null };

export type RequestPlannedArrivalNoticesMutationVariables = Types.Exact<{
  input: Types.RequestPlannedArrivalNoticesInput;
}>;


export type RequestPlannedArrivalNoticesMutation = { __typename?: 'Mutation', requestPlannedArrivalNotices: { __typename?: 'RequestPlannedArrivalNoticesPayload', results: Array<{ __typename?: 'PlannedArrivalNoticeStopResult', routeStopId: string, outcome: Types.PlannedArrivalNoticeRequestOutcome, reservationId?: string | null, changedFields: Array<string>, blockingOrderNumber?: string | null, missingField?: string | null, warnings: Array<{ __typename?: 'PlannedArrivalNoticeWarning', code: Types.PlannedArrivalNoticeWarningCode, orderNumbers: Array<string>, orderDeliveryDate: string, plannedDeliveryDate: string }> }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResolveUncertainLoadEmailMutationVariables = Types.Exact<{
  input: Types.ResolveUncertainLoadEmailInput;
}>;


export type ResolveUncertainLoadEmailMutation = { __typename?: 'Mutation', resolveUncertainLoadEmail: { __typename?: 'LoadEmailPayload', email?: { __typename?: 'LoadEmailDocument', id: string, reservationId: string, status: Types.LoadEmailStatus, attempt: number, version: number, corrected: boolean, plannedTime?: string | null, recipients: Array<string>, failureReason?: string | null, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ComputeLoadMilesMutationVariables = Types.Exact<{
  input: Types.ComputeLoadMilesInput;
}>;


export type ComputeLoadMilesMutation = { __typename?: 'Mutation', computeLoadMiles: { __typename?: 'LoadPayload', load?: { __typename?: 'LoadStateData', tenantId: string, loadId: string, loadNumber: number, routeId?: string | null, vehicleId?: string | null, carrierId?: string | null, driverId?: string | null, shipDate: string, status: Types.LoadStatus, containerConfigId?: string | null, containerName: string, dockId?: string | null, miles?: number | null, milesSource: Types.MilesSource, milesItinerary: Array<string>, transitKind: Types.TransitKind, updatedAt: Types.TDateISO, updatedBy: string, plannedArrivals: Array<{ __typename?: 'PlannedArrivalStateData', routeStopId: string, time: string }>, pickupWindow?: { __typename?: 'PickupWindowStateData', date: string, from: string, to: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RequestFreightQuoteSendMutationVariables = Types.Exact<{
  input: Types.RequestFreightQuoteSendInput;
}>;


export type RequestFreightQuoteSendMutation = { __typename?: 'Mutation', requestFreightQuoteSend: { __typename?: 'RequestFreightQuoteSendPayload', send?: { __typename?: 'FreightQuoteSend', reservationId: string, state: Types.LoadEmailStatus, recipientEmail: string, sentAt?: Types.TDateISO | null, failureReason?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const LogisticsLoadStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}
    `, {"fragmentName":"LogisticsLoadStateFields"});
export const MergeLoadDocument = new TypedDocumentString(`
    mutation MergeLoad($input: MergeLoadInput!) {
  mergeLoad(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const DeleteLoadDocument = new TypedDocumentString(`
    mutation DeleteLoad($input: DeleteLoadInput!) {
  deleteLoad(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const SetLoadMilesDocument = new TypedDocumentString(`
    mutation SetLoadMiles($input: SetLoadMilesInput!) {
  setLoadMiles(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const ClearLoadMilesDocument = new TypedDocumentString(`
    mutation ClearLoadMiles($input: ClearLoadMilesInput!) {
  clearLoadMiles(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const SetLoadPickupWindowDocument = new TypedDocumentString(`
    mutation SetLoadPickupWindow($input: SetLoadPickupWindowInput!) {
  setLoadPickupWindow(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const ClearLoadPickupWindowDocument = new TypedDocumentString(`
    mutation ClearLoadPickupWindow($input: ClearLoadPickupWindowInput!) {
  clearLoadPickupWindow(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const SetLoadTransitKindDocument = new TypedDocumentString(`
    mutation SetLoadTransitKind($input: SetLoadTransitKindInput!) {
  setLoadTransitKind(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const SetLoadDockDocument = new TypedDocumentString(`
    mutation SetLoadDock($input: SetLoadDockInput!) {
  setLoadDock(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const ClearLoadDockDocument = new TypedDocumentString(`
    mutation ClearLoadDock($input: ClearLoadDockInput!) {
  clearLoadDock(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const SetLoadStopPlannedTimeDocument = new TypedDocumentString(`
    mutation SetLoadStopPlannedTime($input: SetLoadStopPlannedTimeInput!) {
  setLoadStopPlannedTime(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const ClearLoadStopPlannedTimeDocument = new TypedDocumentString(`
    mutation ClearLoadStopPlannedTime($input: ClearLoadStopPlannedTimeInput!) {
  clearLoadStopPlannedTime(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const RequestPlannedArrivalNoticesDocument = new TypedDocumentString(`
    mutation RequestPlannedArrivalNotices($input: RequestPlannedArrivalNoticesInput!) {
  requestPlannedArrivalNotices(input: $input) {
    results {
      routeStopId
      outcome
      reservationId
      changedFields
      blockingOrderNumber
      missingField
      warnings {
        ...PlannedArrivalNoticeWarningFields
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment PlannedArrivalNoticeWarningFields on PlannedArrivalNoticeWarning {
  code
  orderNumbers
  orderDeliveryDate
  plannedDeliveryDate
}`);
export const ResolveUncertainLoadEmailDocument = new TypedDocumentString(`
    mutation ResolveUncertainLoadEmail($input: ResolveUncertainLoadEmailInput!) {
  resolveUncertainLoadEmail(input: $input) {
    email {
      ...LoadEmailFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LoadEmailFields on LoadEmailDocument {
  id
  reservationId
  status
  attempt
  version
  corrected
  plannedTime
  recipients
  failureReason
  updatedAt
}`);
export const ComputeLoadMilesDocument = new TypedDocumentString(`
    mutation ComputeLoadMiles($input: ComputeLoadMilesInput!) {
  computeLoadMiles(input: $input) {
    load {
      ...LogisticsLoadStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsLoadStateFields on LoadStateData {
  tenantId
  loadId
  loadNumber
  routeId
  vehicleId
  carrierId
  driverId
  shipDate
  status
  containerConfigId
  containerName
  dockId
  miles
  milesSource
  milesItinerary
  transitKind
  updatedAt
  updatedBy
  plannedArrivals {
    routeStopId
    time
  }
  pickupWindow {
    date
    from
    to
  }
}`);
export const RequestFreightQuoteSendDocument = new TypedDocumentString(`
    mutation RequestFreightQuoteSend($input: RequestFreightQuoteSendInput!) {
  requestFreightQuoteSend(input: $input) {
    send {
      ...FreightQuoteSendFields
    }
    errors {
      code
      message
    }
  }
}
    fragment FreightQuoteSendFields on FreightQuoteSend {
  reservationId
  state
  recipientEmail
  sentAt
  failureReason
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MergeLoad: build.mutation<MergeLoadMutation, MergeLoadMutationVariables>({
      query: (variables) => ({ document: MergeLoadDocument, variables })
    }),
    DeleteLoad: build.mutation<DeleteLoadMutation, DeleteLoadMutationVariables>({
      query: (variables) => ({ document: DeleteLoadDocument, variables })
    }),
    SetLoadMiles: build.mutation<SetLoadMilesMutation, SetLoadMilesMutationVariables>({
      query: (variables) => ({ document: SetLoadMilesDocument, variables })
    }),
    ClearLoadMiles: build.mutation<ClearLoadMilesMutation, ClearLoadMilesMutationVariables>({
      query: (variables) => ({ document: ClearLoadMilesDocument, variables })
    }),
    SetLoadPickupWindow: build.mutation<SetLoadPickupWindowMutation, SetLoadPickupWindowMutationVariables>({
      query: (variables) => ({ document: SetLoadPickupWindowDocument, variables })
    }),
    ClearLoadPickupWindow: build.mutation<ClearLoadPickupWindowMutation, ClearLoadPickupWindowMutationVariables>({
      query: (variables) => ({ document: ClearLoadPickupWindowDocument, variables })
    }),
    SetLoadTransitKind: build.mutation<SetLoadTransitKindMutation, SetLoadTransitKindMutationVariables>({
      query: (variables) => ({ document: SetLoadTransitKindDocument, variables })
    }),
    SetLoadDock: build.mutation<SetLoadDockMutation, SetLoadDockMutationVariables>({
      query: (variables) => ({ document: SetLoadDockDocument, variables })
    }),
    ClearLoadDock: build.mutation<ClearLoadDockMutation, ClearLoadDockMutationVariables>({
      query: (variables) => ({ document: ClearLoadDockDocument, variables })
    }),
    SetLoadStopPlannedTime: build.mutation<SetLoadStopPlannedTimeMutation, SetLoadStopPlannedTimeMutationVariables>({
      query: (variables) => ({ document: SetLoadStopPlannedTimeDocument, variables })
    }),
    ClearLoadStopPlannedTime: build.mutation<ClearLoadStopPlannedTimeMutation, ClearLoadStopPlannedTimeMutationVariables>({
      query: (variables) => ({ document: ClearLoadStopPlannedTimeDocument, variables })
    }),
    RequestPlannedArrivalNotices: build.mutation<RequestPlannedArrivalNoticesMutation, RequestPlannedArrivalNoticesMutationVariables>({
      query: (variables) => ({ document: RequestPlannedArrivalNoticesDocument, variables })
    }),
    ResolveUncertainLoadEmail: build.mutation<ResolveUncertainLoadEmailMutation, ResolveUncertainLoadEmailMutationVariables>({
      query: (variables) => ({ document: ResolveUncertainLoadEmailDocument, variables })
    }),
    ComputeLoadMiles: build.mutation<ComputeLoadMilesMutation, ComputeLoadMilesMutationVariables>({
      query: (variables) => ({ document: ComputeLoadMilesDocument, variables })
    }),
    RequestFreightQuoteSend: build.mutation<RequestFreightQuoteSendMutation, RequestFreightQuoteSendMutationVariables>({
      query: (variables) => ({ document: RequestFreightQuoteSendDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMergeLoadMutation, useDeleteLoadMutation, useSetLoadMilesMutation, useClearLoadMilesMutation, useSetLoadPickupWindowMutation, useClearLoadPickupWindowMutation, useSetLoadTransitKindMutation, useSetLoadDockMutation, useClearLoadDockMutation, useSetLoadStopPlannedTimeMutation, useClearLoadStopPlannedTimeMutation, useRequestPlannedArrivalNoticesMutation, useResolveUncertainLoadEmailMutation, useComputeLoadMilesMutation, useRequestFreightQuoteSendMutation } = injectedRtkApi;
